module.exports = __webpack_public_path__ + "img/myposition_cm_차비 에르난데스.d70e36fc.png";